export const SET_ENDERECOS = 'SET_ENDERECOS';
export const LOADING_ENDERECOS = 'LOADING_ENDERECOS';